/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import { Pill } from 'components/atoms/Pill'
import { LazyDmeNotesPopover } from 'components/dme/order/LazyDmeNotesPopover'

interface IProps {
  orderId: number
  count?: number
  physician?: boolean
  to?: string
}

export const SchedulingNotesPill = ({ orderId, count, physician, to }: IProps) =>
  count ? (
    <LazyDmeNotesPopover orderId={orderId} filterScheduling physician={physician}>
      <div className="w-100">
        <Pill
          css={css`
            background-color: lightblue;
            border: 1px solid #07b5ff80;
          `}
          to={to}>
          {count} Note{count > 1 ? 's' : ''}
        </Pill>
      </div>
    </LazyDmeNotesPopover>
  ) : (
    <>-</>
  )
